import ChangePermissions from './ChangePermissions';
export default ChangePermissions;
